import { Container, Row, Col } from "reactstrap";
import { MisterLogo } from "@rtel/mister-icons";
import pkgJSON from "./../../../package.json";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const applicationVersion = pkgJSON.version;

  return (
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col xs={6}>
              <MisterLogo name="MisterRtelWorldLogo" isActive={true} />
            </Col>
            <Col xs={6}>
              <div className="text-sm-end d-none d-sm-block">
                {`©RTEL World LLC 2014-${currentYear} v${applicationVersion}`}
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
  );
};

export default Footer;
